import { render, staticRenderFns } from "./wholesale-margins.vue?vue&type=template&id=880ac060"
import script from "./wholesale-margins.vue?vue&type=script&lang=js"
export * from "./wholesale-margins.vue?vue&type=script&lang=js"
import style0 from "./wholesale-margins.vue?vue&type=style&index=0&id=880ac060&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports